import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import { DataSourceRequest } from "@/model/DataSourceRequest";
import { DataSourceResult } from "@/model/DataSourceResult";


export async function getPlans(active = true): Promise<any[]> {
  //alert("abc");
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: 1,
    pageSize: 500,
    filters: [
      { field: "active", operator: active ? "gt" : "eq", value: 0 }
    ],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  const res = await axiosInstance.post<DataSourceResult<any>>("/SubscriptionPlans/GetPackageList", body, { headers });
  return res.data?.data;
}


export async function addNewPackage(data) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post("/SubscriptionPlans/AddNewPackage", data, { headers })).data;
}
export async function saveRegion(data) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post("/Areas/save", data, { headers })).data;
}
export async function updatekhuVuc(data) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post("/Areas/save", data, { headers })).data;
}
export async function getPackageDetail(id: number) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.get(`/SubscriptionPlans/GetPackageDetail/${id}`, { headers })).data;
}


export async function updatePackage(data) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post("/SubscriptionPlans/UpdatePackage", data, { headers })).data;
}


export async function deletePackage(id: number) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post("/SubscriptionPlans/DeletePackage", null, {
    headers,
    params: { id }
  })).data;
}


export async function getCustomerSubscription(customerId: number): Promise<any[]> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: 1,
    pageSize: 100,
    filters: [
      { field: "customerId", operator: "eq", value: customerId, logic: "and" }
    ],
    sorts: [
      { field: "id", dir: "asc" }
    ]
  };

  return (await axiosInstance.post<DataSourceResult<any>>(
    "/CustomerSubscription/GetCustomerSubscriptionList",
    body,
    { headers }
  )).data.data;
}

export async function getCustomerStorageSubscriptionHistoryList(customerId: number): Promise<any[]> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: 1,
    pageSize: 100,
    filters: [
      { field: "customerId", operator: "eq", value: customerId, logic: "and" }
    ],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  return (await axiosInstance.post<DataSourceResult<any>>(
    "/CustomerSubscription/StorageSubscriptionHistoryList",
    body,
    { headers }
  )).data.data;
}

export async function getCustomerSubscriptionHistoryList(customerId: number): Promise<any[]> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page: 1,
    pageSize: 100,
    filters: [
      { field: "customerId", operator: "eq", value: customerId, logic: "and" }
    ],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  return (await axiosInstance.post<DataSourceResult<any>>(
    "/CustomerSubscription/GetCustomerSubscriptionHistoryList",
    body,
    { headers }
  )).data.data;
}

export async function getPlanTypeList() {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.get(`/SubscriptionPlans/PlanTypeList`, { headers })).data;
}

export async function getCorePlanTypeList(params) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get(`/SubscriptionPlans/CorePlanTypeList`, { headers, params })).data;
}

export async function actionCorePlanType(id) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/SubscriptionPlans/ActionCorePlanType/" + id, null, {
    headers,
  })).data;
}

export async function detailCorePlanType(id) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/SubscriptionPlans/DetailCorePlanType/" + id, { headers })).data;
}

export async function updateCorePlanType(body) {
  const headers = userService.getAuthHeaders();

  return (await axiosInstance.post<DataSourceResult<any>>(
    "/SubscriptionPlans/UpdateCorePlanType",
    body,
    { headers }
  )).data.data;
}

export async function addCorePlanType(body) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post<DataSourceResult<any>>(
    "/SubscriptionPlans/AddCorePlanType",
    body,
    { headers }
  )).data.data;
}

export async function getAllSubs(page: number, pageSize: number, q?: string): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page,
    pageSize,
    sorts: [
      { field: "name", dir: "asc" }
    ]
  };

  if (q) {
    body.filters = [
      { field: "name", operator: "contains", value: q, logic: "or" },
      { field: "email", operator: "contains", value: q, logic: "or" },
      { field: "phone", operator: "contains", value: q, logic: "or" },
    ];
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/SubscriptionPlans/GetPackageList", body, { headers })).data;
}
